/**
 * Ticket changes from the socket to the query cache, so the board, a ticket page, an account's
 * tickets and the bell refresh on their own (Jeff, 2026-10-22: "if someone else creates a ticket
 * it should pop up automagically. remember speed"). The ticket itself refetches at once; the
 * board and account lists coalesce a burst (several changes in a row cost one refetch).
 */
import { type QueryClient } from '@tanstack/react-query';
import { type TicketNotice } from './live';

const BURST_MS = 250;

export function liveTicketRefetch(qc: QueryClient, opts: { myProfileId?: () => string | null; burstMs?: number } = {}) {
  const burstMs = opts.burstMs ?? BURST_MS;
  let timer: ReturnType<typeof setTimeout> | null = null;
  let listsDirty = false;
  const flushLists = () => {
    timer = null;
    if (!listsDirty) return;
    listsDirty = false;
    void qc.invalidateQueries({ queryKey: ['tickets.board'] });
    void qc.invalidateQueries({ queryKey: ['accounts.get'] });
    void qc.invalidateQueries({ queryKey: ['calls.list'] });
    void qc.invalidateQueries({ queryKey: ['overview.get'] });
  };
  return {
    onTicket(n: TicketNotice) {
      void qc.invalidateQueries({ queryKey: ['tickets.get', n.ticketId] });
      listsDirty = true;
      timer ??= setTimeout(flushLists, burstMs);
      const me = opts.myProfileId?.() ?? null;
      if (n.mentioned.length > 0 && (me === null || n.mentioned.includes(me))) void qc.invalidateQueries({ queryKey: ['notifications.list'] });
    },
    stop() {
      if (timer) clearTimeout(timer);
      timer = null;
    },
  };
}
